// extracted by mini-css-extract-plugin
export default {"card":"R2-z"};